import React, { useEffect,useState } from "react";
import EdexBalence from "./components/EdexBalence";
import NetWorkBalance from "./components/NetWorkBalance";
import SelectNetwork from "./components/SelectToNetwork";
import { useConnectWallet, useWallets, useSetChain } from "@web3-onboard/react";
import { ethers } from "ethers";
import ERC20ABI from "./../../../../assets/abi/erc20_ABI.json";
let erc20, provider,contract;
function ToNetworkContainer({ netWroks, setNetWroks,toBalance }) {
  const [{ chains, connectedChain, settingChain }, setChain] = useSetChain();
  // const [balance, setBalance] = React.useState(0);
  const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, [toBalance]);

  const setNetwrokForTo = (param) => {
    setNetWroks((prev) => {
      const arr = [];
      for (let i = 0; i < prev.length; i++) {
        const element = prev[i];
        if (element.name === param.name) {
          element.isSelectedAsTo = true;
          
        } else {
          element.isSelectedAsTo = false;
          
        }
        arr.push(element);
      }
      return [...arr];
    });
  };

  function formatAmount(amount) {
    // Convert amount to string
    let amountStr = amount.toString();
  
    // Check if there is a decimal point
    if (amountStr.includes('.')) {
        // Split the string into integer and decimal parts
        let parts = amountStr.split('.');
        // Limit the decimal part to 3 digits
        parts[1] = parts[1].substring(0, 3);
        // Join the parts back together
        return parts.join('.');
    } else {
        // If there's no decimal point, return the amount with '.000'
        return amountStr + '.000';
    }
  }


  // async function getBalance(){
  //   try{
  //   if (wallet && wallet.chains&&connectedChain.id) {
        
  //     for (let i = 0; i < netWroks.length; i++) {
  //       const element = netWroks[i];
  //       if (element.isSelectedAsTo&&element.chainId!=connectedChain.id) {
              
  //         switch (element.name) {
  //               case "ethereum-testnet":
  //                 erc20 = "0x5052d653FAE897feE36863aEedd2aaFBbC3B9fe9";
  //                 provider = new ethers.providers.JsonRpcProvider("https://eth-sepolia.public.blastapi.io");
  //                 contract = new ethers.Contract(erc20, ERC20ABI, provider);
  //                 setBalance(Number(ethers.utils.formatEther(await contract.balanceOf(wallet.accounts[0].address))))
  //                 break;
  //               case "polygon-testnet":
  //                 erc20 = "0xDA262cA54D76ae5dc730CA9DdE2F40E115386DC2";
  //                 provider = new ethers.providers.JsonRpcProvider("https://rpc.ankr.com/polygon_amoy");
  //                 contract = new ethers.Contract(erc20, ERC20ABI, provider);
  //                 setBalance(Number(ethers.utils.formatEther(await contract.balanceOf(wallet.accounts[0].address))))
  //                 break;
  //               case "bsc-testnet":
  //                 erc20 = "0x0332f7Fa834E9B8A75d15B11c8cFe2bC162CE12E";
  //                 provider = new ethers.providers.JsonRpcProvider("https://data-seed-prebsc-1-s1.binance.org:8545/");
  //                 contract = new ethers.Contract(erc20, ERC20ABI, provider);
  //                 setBalance(Number(ethers.utils.formatEther(await contract.balanceOf(wallet.accounts[0].address))))
  //                 break;
  //               default:setBalance(0);
            
  //         }
  //       } 
  //     }
  //   } }catch(error){} 
  // }
     
  
  // useEffect(() => {
  //   if(!wallet) setBalance(0)
  //     getBalance();
   
  // },[wallet,netWroks]);
    



  // setInterval(() => {
  //   getBalance();
  // }, 2000);
  
  return (
    <div className="p-4">
      <NetWorkBalance />
      <div className="flex justify-between pt-2 ">
        <div className="flex">
          <SelectNetwork networks={netWroks} setNetwork={setNetwrokForTo} />
          {/* <div>
            <img className="mr-3" src={LogoX} alt="logox" />
          </div>
          <p className="">edeXa</p> */}
        </div>

        <div>   
          {/* <EdexBalence networks={netWroks} /> */}
          {/* <span className="font-semibold" style={{ fontSize: '13px',fontWeight:500 }}> {toBalance.toString()} EDX</span> */}
          {isLoading ? (
              <div className="w-4 h-4 border-4 border-t-4 border-gray-400 border-t-gray-600 rounded-full animate-spin"></div>
          ) : (
            <span className="font-semibold" style={{ fontSize: '13px', fontWeight: 500 }}>
              {formatAmount(toBalance.toString())} EDX
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ToNetworkContainer;